<template>
  <a-RenderHTML :value="translationTerminationInstructions" />
</template>

<script>
import Vue from 'vue';
import i18nCommon from '@modules/i18n/mixins/Common';
import RenderHTML from '@modules/design-system/components/atoms/RenderHTML.vue';

export default Vue.extend({
  name: 'TenancyDepositReleaseManual',
  mixins: [i18nCommon],
  components: {
    'a-RenderHTML': RenderHTML,
  },
  computed: {
    translationTerminationInstructions() {
      return this.translate('tenancyDeposit.md-deposit termination instructions');
    },
  },
});
</script>
